import { createSlice } from "@reduxjs/toolkit";

const initialState = { open: false, prevOpen: null };

export const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    toggleDrawer(state, action) {
      state.open = !state.open;
    },
    closeDrawer(state, action) {
      state.open = false;
    },
    backToPrevState(state, action) {
      if (state.prevOpen !== state.open && state.prevOpen !== null) {
        state.open = state.prevOpen;
        state.prevOpen = null;
      }
    },
    keepOpenDrawer(state, action) {
      if (state.open !== true) {
        state.open = true;
        state.prevOpen = false;
      }
    },
  },
});
export const { toggleDrawer, backToPrevState, keepOpenDrawer, closeDrawer } =
  drawerSlice.actions;
export const drawerReducer = drawerSlice.reducer;
